module.exports = __webpack_public_path__ + "img/usericon.4b973909.svg";